import { getErrorMessage, normalizeError } from '@/core/error-handling/ApiErrorHandler';

/** The copy a person sees for anything thrown -- always through the platform's one error path. */
export function messageOf(error: unknown): string {
  return getErrorMessage(normalizeError(error));
}

/** Hands a downloaded file to the browser under its own name. */
export function saveFile(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  /* Released immediately: the click has already taken its own reference. */
  URL.revokeObjectURL(url);
}
